import SysDialog from "@/components/padraoDeLayout/SysDialog";

export default {
  components: {SysDialog},
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props:{
    modelValue: Boolean,
    relatorio: Object,
  },
  computed: {
    DIALOG_ATIVO: {
      get() {
        return this.modelValue
      },
      set(valor) {
        return this.$emit('update:modelValue', valor);
      }
    }
  }
}
